module.exports = __webpack_public_path__ + "static/media/mumbai.c6dbe940.svg";